import React, { useContext } from 'react';
import map from 'lodash/map';

import { ThreadModuleContext } from '../ThreadModuleContext';

import ExternalActionInput from './ExternalActionInput';

type ExternalActionProps = {
  disabled: boolean;
};

const ExternalAction = ({ disabled }: ExternalActionProps) => {
  const { module } = useContext(ThreadModuleContext);

  if (!module?.externalAction?.inputs?.length) {
    return null;
  }

  return (
    <>
      {map(module?.externalAction?.inputs, (input, index) => {
        return (
          <ExternalActionInput
            attr={`externalAction.inputs[${index}]`}
            disabled={disabled}
            key={input.name}
            input={input}
            module={module}
          />
        );
      })}
    </>
  );
};

export default ExternalAction;
